/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiPetAllergy,
  ApiPetAllergyFromJSON,
  ApiPetAllergyFromJSONTyped,
  ApiPetAllergyToJSON,
} from './ApiPetAllergy';
import {
  ApiPetBreedReference,
  ApiPetBreedReferenceFromJSON,
  ApiPetBreedReferenceFromJSONTyped,
  ApiPetBreedReferenceToJSON,
} from './ApiPetBreedReference';
import {
  ApiPetDerived,
  ApiPetDerivedFromJSON,
  ApiPetDerivedFromJSONTyped,
  ApiPetDerivedToJSON,
} from './ApiPetDerived';
import {
  ApiPetMedicalCondition,
  ApiPetMedicalConditionFromJSON,
  ApiPetMedicalConditionFromJSONTyped,
  ApiPetMedicalConditionToJSON,
} from './ApiPetMedicalCondition';
import {
  ApiPetMedication,
  ApiPetMedicationFromJSON,
  ApiPetMedicationFromJSONTyped,
  ApiPetMedicationToJSON,
} from './ApiPetMedication';
import {
  ApiPetMedicationAllergy,
  ApiPetMedicationAllergyFromJSON,
  ApiPetMedicationAllergyFromJSONTyped,
  ApiPetMedicationAllergyToJSON,
} from './ApiPetMedicationAllergy';
import {
  ApiPetPrimaryDiscipline,
  ApiPetPrimaryDisciplineFromJSON,
  ApiPetPrimaryDisciplineFromJSONTyped,
  ApiPetPrimaryDisciplineToJSON,
} from './ApiPetPrimaryDiscipline';
import {
  ApiPetProfileAvatar,
  ApiPetProfileAvatarFromJSON,
  ApiPetProfileAvatarFromJSONTyped,
  ApiPetProfileAvatarToJSON,
} from './ApiPetProfileAvatar';
import {
  ApiPetRidingStyle,
  ApiPetRidingStyleFromJSON,
  ApiPetRidingStyleFromJSONTyped,
  ApiPetRidingStyleToJSON,
} from './ApiPetRidingStyle';
import {
  ApiPetType,
  ApiPetTypeFromJSON,
  ApiPetTypeFromJSONTyped,
  ApiPetTypeToJSON,
} from './ApiPetType';
import {
  ApiSubmitter,
  ApiSubmitterFromJSON,
  ApiSubmitterFromJSONTyped,
  ApiSubmitterToJSON,
} from './ApiSubmitter';

/**
 *
 * @export
 * @interface ApiPetProfile
 */
export interface ApiPetProfile {
  /**
   * System assigned. Not modifiable during creation or update.
   * @type {number}
   * @memberof ApiPetProfile
   */
  id?: number;
  /**
   *
   * @type {ApiSubmitter}
   * @memberof ApiPetProfile
   */
  submitter?: ApiSubmitter;
  /**
   *
   * @type {number}
   * @memberof ApiPetProfile
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetProfile
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetProfile
   */
  ownerName?: string;
  /**
   *
   * @type {ApiPetType}
   * @memberof ApiPetProfile
   */
  type: ApiPetType;
  /**
   *
   * @type {string}
   * @memberof ApiPetProfile
   */
  gender?: ApiPetProfileGenderEnum;
  /**
   *
   * @type {ApiPetDerived}
   * @memberof ApiPetProfile
   */
  derived?: ApiPetDerived;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetProfile
   */
  sterilization?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetProfile
   */
  assistanceAnimal?: boolean | null;
  /**
   * Current age in months.
   * @type {number}
   * @memberof ApiPetProfile
   */
  age?: number | null;
  /**
   * System assigned. Not modifiable during creation or update.
   * @type {boolean}
   * @memberof ApiPetProfile
   */
  readonly birthdayEstimated?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiPetProfile
   */
  birthday?: string | null;
  /**
   * System assigned. Not modifiable during creation or update.
   * @type {string}
   * @memberof ApiPetProfile
   */
  readonly lifestage?: ApiPetProfileLifestageEnum;
  /**
   * System assigned. Not modifiable during creation or update.
   * @type {boolean}
   * @memberof ApiPetProfile
   */
  readonly adopted?: boolean;
  /**
   * remove adoption date on PATCH if cannot set adoption date to null
   * @type {boolean}
   * @memberof ApiPetProfile
   */
  markAdoptionForDeletion?: boolean;
  /**
   * Set to null to remove on PATCH
   * @type {string}
   * @memberof ApiPetProfile
   */
  adoptionDate?: string | null;
  /**
   * unique identifier to store “model Id” for a pet profile. This is not related to existing petAvatar object.
   * @type {string}
   * @memberof ApiPetProfile
   */
  avatarModelId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiPetProfile
   */
  size?: ApiPetProfileSizeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiPetProfile
   */
  fullGrownSize?: ApiPetProfileFullGrownSizeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiPetProfile
   */
  weightType?: ApiPetProfileWeightTypeEnum;
  /**
   *
   * @type {number}
   * @memberof ApiPetProfile
   */
  weight?: number | null;
  /**
   * Only modifiable during creation.
   * @type {string}
   * @memberof ApiPetProfile
   */
  source?: ApiPetProfileSourceEnum;
  /**
   * Only modifiable during update.
   * @type {string}
   * @memberof ApiPetProfile
   */
  status?: ApiPetProfileStatusEnum;
  /**
   * Only modifiable during update.
   * @type {string}
   * @memberof ApiPetProfile
   */
  statusReason?: ApiPetProfileStatusReasonEnum;
  /**
   *
   * @type {Array<ApiPetBreedReference>}
   * @memberof ApiPetProfile
   */
  breeds?: Array<ApiPetBreedReference>;
  /**
   *
   * @type {Array<ApiPetRidingStyle>}
   * @memberof ApiPetProfile
   */
  ridingStyles?: Array<ApiPetRidingStyle>;
  /**
   *
   * @type {Array<ApiPetPrimaryDiscipline>}
   * @memberof ApiPetProfile
   */
  primaryDisciplines?: Array<ApiPetPrimaryDiscipline>;
  /**
   *
   * @type {Array<ApiPetAllergy>}
   * @memberof ApiPetProfile
   */
  allergies?: Array<ApiPetAllergy>;
  /**
   *
   * @type {Array<ApiPetMedication>}
   * @memberof ApiPetProfile
   */
  medications?: Array<ApiPetMedication>;
  /**
   *
   * @type {Array<ApiPetMedicationAllergy>}
   * @memberof ApiPetProfile
   */
  medicationAllergies?: Array<ApiPetMedicationAllergy>;
  /**
   *
   * @type {Array<ApiPetMedicalCondition>}
   * @memberof ApiPetProfile
   */
  medicalConditions?: Array<ApiPetMedicalCondition>;
  /**
   * Set to null to remove on PATCH
   * @type {string}
   * @memberof ApiPetProfile
   */
  bannerImageUri?: string | null;
  /**
   * remove banner image on PATCH if cannot set bannerImageUri to null
   * @type {boolean}
   * @memberof ApiPetProfile
   */
  markBannerImageForDeletion?: boolean;
  /**
   *
   * @type {ApiPetProfileAvatar}
   * @memberof ApiPetProfile
   */
  avatar?: ApiPetProfileAvatar | null;
}

/**
 * @export
 */
export const ApiPetProfileGenderEnum = {
  Unknown: 'UNKNOWN',
  Male: 'MALE',
  Female: 'FEMALE',
} as const;
export type ApiPetProfileGenderEnum = typeof ApiPetProfileGenderEnum[keyof typeof ApiPetProfileGenderEnum];

/**
 * @export
 */
export const ApiPetProfileLifestageEnum = {
  Unknown: 'UNKNOWN',
  Senior: 'SENIOR',
  Adult: 'ADULT',
  Puppy: 'PUPPY',
  Kitten: 'KITTEN',
} as const;
export type ApiPetProfileLifestageEnum = typeof ApiPetProfileLifestageEnum[keyof typeof ApiPetProfileLifestageEnum];

/**
 * @export
 */
export const ApiPetProfileSizeEnum = {
  Unknown: 'UNKNOWN',
  Xs: 'XS',
  Sm: 'SM',
  M: 'M',
  L: 'L',
  Xl: 'XL',
  G: 'G',
} as const;
export type ApiPetProfileSizeEnum = typeof ApiPetProfileSizeEnum[keyof typeof ApiPetProfileSizeEnum];

/**
 * @export
 */
export const ApiPetProfileFullGrownSizeEnum = {
  Unknown: 'UNKNOWN',
  Xs: 'XS',
  Sm: 'SM',
  M: 'M',
  L: 'L',
  Xl: 'XL',
  G: 'G',
} as const;
export type ApiPetProfileFullGrownSizeEnum = typeof ApiPetProfileFullGrownSizeEnum[keyof typeof ApiPetProfileFullGrownSizeEnum];

/**
 * @export
 */
export const ApiPetProfileWeightTypeEnum = {
  Unknown: 'UNKNOWN',
  Underweight: 'UNDERWEIGHT',
  Healthy: 'HEALTHY',
  Overweight: 'OVERWEIGHT',
} as const;
export type ApiPetProfileWeightTypeEnum = typeof ApiPetProfileWeightTypeEnum[keyof typeof ApiPetProfileWeightTypeEnum];

/**
 * @export
 */
export const ApiPetProfileSourceEnum = {
  Unknown: 'UNKNOWN',
  AdoptAPet: 'ADOPT_A_PET',
  ShelterLuv: 'SHELTER_LUV',
  RescueGroup: 'RESCUE_GROUP',
} as const;
export type ApiPetProfileSourceEnum = typeof ApiPetProfileSourceEnum[keyof typeof ApiPetProfileSourceEnum];

/**
 * @export
 */
export const ApiPetProfileStatusEnum = {
  Unknown: 'UNKNOWN',
  Inactive: 'INACTIVE',
  Active: 'ACTIVE',
  Deleted: 'DELETED',
} as const;
export type ApiPetProfileStatusEnum = typeof ApiPetProfileStatusEnum[keyof typeof ApiPetProfileStatusEnum];

/**
 * @export
 */
export const ApiPetProfileStatusReasonEnum = {
  Unknown: 'UNKNOWN',
  Deceased: 'DECEASED',
  SwitchedRetailers: 'SWITCHED_RETAILERS',
  Other: 'OTHER',
} as const;
export type ApiPetProfileStatusReasonEnum = typeof ApiPetProfileStatusReasonEnum[keyof typeof ApiPetProfileStatusReasonEnum];

export function ApiPetProfileFromJSON(json: any): ApiPetProfile {
  return ApiPetProfileFromJSONTyped(json, false);
}

export function ApiPetProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPetProfile {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    submitter: !exists(json, 'submitter') ? undefined : ApiSubmitterFromJSON(json['submitter']),
    userId: !exists(json, 'userId') ? undefined : json['userId'],
    name: json['name'],
    ownerName: !exists(json, 'ownerName') ? undefined : json['ownerName'],
    type: ApiPetTypeFromJSON(json['type']),
    gender: !exists(json, 'gender') ? undefined : json['gender'],
    derived: !exists(json, 'derived') ? undefined : ApiPetDerivedFromJSON(json['derived']),
    sterilization: !exists(json, 'sterilization') ? undefined : json['sterilization'],
    assistanceAnimal: !exists(json, 'assistanceAnimal') ? undefined : json['assistanceAnimal'],
    age: !exists(json, 'age') ? undefined : json['age'],
    birthdayEstimated: !exists(json, 'birthdayEstimated') ? undefined : json['birthdayEstimated'],
    birthday: !exists(json, 'birthday') ? undefined : json['birthday'],
    lifestage: !exists(json, 'lifestage') ? undefined : json['lifestage'],
    adopted: !exists(json, 'adopted') ? undefined : json['adopted'],
    markAdoptionForDeletion: !exists(json, 'markAdoptionForDeletion')
      ? undefined
      : json['markAdoptionForDeletion'],
    adoptionDate: !exists(json, 'adoptionDate') ? undefined : json['adoptionDate'],
    avatarModelId: !exists(json, 'avatarModelId') ? undefined : json['avatarModelId'],
    size: !exists(json, 'size') ? undefined : json['size'],
    fullGrownSize: !exists(json, 'fullGrownSize') ? undefined : json['fullGrownSize'],
    weightType: !exists(json, 'weightType') ? undefined : json['weightType'],
    weight: !exists(json, 'weight') ? undefined : json['weight'],
    source: !exists(json, 'source') ? undefined : json['source'],
    status: !exists(json, 'status') ? undefined : json['status'],
    statusReason: !exists(json, 'statusReason') ? undefined : json['statusReason'],
    breeds: !exists(json, 'breeds')
      ? undefined
      : (json['breeds'] as Array<any>).map(ApiPetBreedReferenceFromJSON),
    ridingStyles: !exists(json, 'ridingStyles')
      ? undefined
      : (json['ridingStyles'] as Array<any>).map(ApiPetRidingStyleFromJSON),
    primaryDisciplines: !exists(json, 'primaryDisciplines')
      ? undefined
      : (json['primaryDisciplines'] as Array<any>).map(ApiPetPrimaryDisciplineFromJSON),
    allergies: !exists(json, 'allergies')
      ? undefined
      : (json['allergies'] as Array<any>).map(ApiPetAllergyFromJSON),
    medications: !exists(json, 'medications')
      ? undefined
      : (json['medications'] as Array<any>).map(ApiPetMedicationFromJSON),
    medicationAllergies: !exists(json, 'medicationAllergies')
      ? undefined
      : (json['medicationAllergies'] as Array<any>).map(ApiPetMedicationAllergyFromJSON),
    medicalConditions: !exists(json, 'medicalConditions')
      ? undefined
      : (json['medicalConditions'] as Array<any>).map(ApiPetMedicalConditionFromJSON),
    bannerImageUri: !exists(json, 'bannerImageUri') ? undefined : json['bannerImageUri'],
    markBannerImageForDeletion: !exists(json, 'markBannerImageForDeletion')
      ? undefined
      : json['markBannerImageForDeletion'],
    avatar: !exists(json, 'avatar') ? undefined : ApiPetProfileAvatarFromJSON(json['avatar']),
  };
}

export function ApiPetProfileToJSON(value?: ApiPetProfile | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    submitter: ApiSubmitterToJSON(value.submitter),
    userId: value.userId,
    name: value.name,
    ownerName: value.ownerName,
    type: ApiPetTypeToJSON(value.type),
    gender: value.gender,
    derived: ApiPetDerivedToJSON(value.derived),
    sterilization: value.sterilization,
    assistanceAnimal: value.assistanceAnimal,
    age: value.age,
    birthday: value.birthday,
    markAdoptionForDeletion: value.markAdoptionForDeletion,
    adoptionDate: value.adoptionDate,
    avatarModelId: value.avatarModelId,
    size: value.size,
    fullGrownSize: value.fullGrownSize,
    weightType: value.weightType,
    weight: value.weight,
    source: value.source,
    status: value.status,
    statusReason: value.statusReason,
    breeds:
      value.breeds === undefined
        ? undefined
        : (value.breeds as Array<any>).map(ApiPetBreedReferenceToJSON),
    ridingStyles:
      value.ridingStyles === undefined
        ? undefined
        : (value.ridingStyles as Array<any>).map(ApiPetRidingStyleToJSON),
    primaryDisciplines:
      value.primaryDisciplines === undefined
        ? undefined
        : (value.primaryDisciplines as Array<any>).map(ApiPetPrimaryDisciplineToJSON),
    allergies:
      value.allergies === undefined
        ? undefined
        : (value.allergies as Array<any>).map(ApiPetAllergyToJSON),
    medications:
      value.medications === undefined
        ? undefined
        : (value.medications as Array<any>).map(ApiPetMedicationToJSON),
    medicationAllergies:
      value.medicationAllergies === undefined
        ? undefined
        : (value.medicationAllergies as Array<any>).map(ApiPetMedicationAllergyToJSON),
    medicalConditions:
      value.medicalConditions === undefined
        ? undefined
        : (value.medicalConditions as Array<any>).map(ApiPetMedicalConditionToJSON),
    bannerImageUri: value.bannerImageUri,
    markBannerImageForDeletion: value.markBannerImageForDeletion,
    avatar: ApiPetProfileAvatarToJSON(value.avatar),
  };
}
